import React, { useMemo } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { cn } from '@/utils';

export interface MarkdownProps {
  markdown: string;
  className?: string;
}

const ALLOWED_TAGS = [
  'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li',
  'a', 'strong', 'em', 'code', 'pre', 'blockquote',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
  'br', 'hr', 'img', 'del', 'sup', 'sub',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'src', 'alt', 'title'];

const sanitizeHtml = (html: string) =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });

marked.setOptions({ breaks: true, gfm: true });

const Markdown: React.FC<MarkdownProps> = ({ markdown, className }) => {
  const content = useMemo(() => markdown || '', [markdown]);
  const html = useMemo(
    () => sanitizeHtml(marked.parse(content, { async: false }) as string),
    [content]
  );

  if (!content.trim()) {
    return null;
  }

  return (
    <div
      className={cn(
        'prose max-w-none prose-th:whitespace-nowrap prose-td:whitespace-nowrap prose-p:whitespace-pre-wrap prose-ul:list-disc prose-ol:list-decimal',
        className
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default Markdown;